import type { ICampaignAnalyticMetricDetectKey } from '~/modules/campaign-analytics';
import type { CampaignPriority } from '~/types/graphql';

import { IAnalyticSummaryResult } from '../types';

export const VARIANT_CONFIG: Record<
  IAnalyticSummaryResult.VARIANT_A | IAnalyticSummaryResult.VARIANT_B,
  {
    icon: string;
    label: string;
    tone: 'active' | 'inactive';
    className: string;
  }
> = {
  [IAnalyticSummaryResult.VARIANT_A]: {
    icon: 'A',
    label: 'Control',
    tone: 'active',
    className: 'text-variant-a',
  },
  [IAnalyticSummaryResult.VARIANT_B]: {
    icon: 'B',
    label: 'Variant',
    tone: 'inactive',
    className: 'text-variant-b',
  },
};

export const METRIC_NAME: Partial<Record<ICampaignAnalyticMetricDetectKey, string>> = {
  conversionRateMetric: 'Conversion rate',
  rpvMetric: 'Revenue per visitor',
  aovMetric: 'Average order value',
  totalRevenueMetric: 'Revenue',
};

export const METRICS_BY_GOAL: Record<CampaignPriority, (keyof typeof METRIC_NAME)[]> = {
  REVENUE: ['totalRevenueMetric', 'conversionRateMetric', 'rpvMetric'],
  CONVERSION: ['conversionRateMetric', 'aovMetric', 'rpvMetric'],
  PROFIT: ['aovMetric', 'conversionRateMetric', 'totalRevenueMetric'],
};
